import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { api } from "../services/api";
import { useAuth } from "../contexts/AuthContext";
import { PublicRoute } from "../components/route/PublicRoute";
import { jwtDecode } from "jwt-decode";
import { UserInfo } from "../types";
import React, { useState } from "react";
import { FeatureTour } from "@/components/common/FeatureTour";

const isChromeExtension = typeof chrome !== "undefined" && !!chrome.runtime && !!chrome.runtime.id;

console.log("isChromeExtension", isChromeExtension);

const clientId = isChromeExtension
  ? "270682995926-q5liupv47dnuvd9g0ofk19kiii2shpva.apps.googleusercontent.com"
  : "270682995926-36p33ghao9bqivffuv3vj884spjei8no.apps.googleusercontent.com";


console.log("origin:", window.location.origin);
// console.log("chrome.identity:", chrome.identity);

export default function LoginPage() {
  const { login } = useAuth();

  const handleGoogleSuccess = async (credentialResponse: any) => {
    try {
      const info: any = jwtDecode(credentialResponse.credential);
      const userPayload: UserInfo = {
        name: info.name,
        email: info.email,
        avatar: info.picture,
        google_id: info.sub,
      };
      const response = await api.googleAuth(userPayload);

      if (response?.data?.token) {
        login(response.data.token);
      } else {
        throw new Error('No token returned from backend');
      }
    } catch (error) {
      console.error('Error during Google login/auth:', error);
      alert('Login failed. Please try again.');
    }
  };

  const handleExtensionLogin = async () => {
    console.log('[LoginPage] Extension login button clicked');
    chrome.runtime.sendMessage({ type: "OPEN_AUTH_WINDOW" });

    // Listen for the result
    const listener = async (msg: any) => {
      console.log('[LoginPage] Received message:', msg);
      if (msg.type === "OAUTH_RESULT") {
        console.log('[LoginPage] Received OAUTH_RESULT message:', msg);
        chrome.runtime.onMessage.removeListener(listener);

        if (msg.userInfo) {
          const userPayload: UserInfo = {
            name: msg.userInfo.name,
            email: msg.userInfo.email,
            avatar: msg.userInfo.picture,
            google_id: msg.userInfo.sub,
          };
          console.log('[LoginPage] Calling api.googleAuth with:', userPayload);
          const response = await api.googleAuth(userPayload);
          console.log('[LoginPage] api.googleAuth response:', response);

          if (response?.data?.token) {
            login(response.data.token);
          } else {
            throw new Error('No token returned from backend');
          }
        }
        if (msg.error) {
          console.error('[LoginPage] Error received from popup:', msg.error);
        }
      }
    };
    chrome.runtime.onMessage.addListener(listener);
  };

  return (
    <PublicRoute>
      <div className="bg-gradient-to-b from-orange-400 via-orange-100 to-white min-h-screen flex flex-row">
        <div className="fixed inset-0 pointer-events-none z-0 w-full h-full">
          <svg width="100%" height="100%" className="w-full h-full animate-pulse-slow" style={{ position: 'absolute', top: 0, left: 0 }}>
            <circle cx="30%" cy="30%" r="180" fill="none" stroke="#fbb6ce" strokeWidth="2" opacity="0.2">
              <animate attributeName="r" values="180;200;180" dur="6s" repeatCount="indefinite" />
            </circle>
            <circle cx="70%" cy="60%" r="120" fill="none" stroke="#a5b4fc" strokeWidth="2" opacity="0.15">
              <animate attributeName="r" values="120;140;120" dur="7s" repeatCount="indefinite" />
            </circle>
            <path d="M 0 400 Q 400 200 1200 400" stroke="#f472b6" strokeWidth="1.5" fill="none" opacity="0.12">
              <animate attributeName="d" values="M 0 400 Q 400 200 1200 400;M 0 420 Q 400 220 1200 420;M 0 400 Q 400 200 1200 400" dur="8s" repeatCount="indefinite" />
            </path>
          </svg>
        </div>
        {/* Feature Tour: 70% */}
        <div className="flex-[6_0_0%] flex items-center justify-center">
          <FeatureTour showDescription={true} />
        </div>
        {/* Sign In: 30% */}
        <div className="flex-[4_0_0%] flex flex-col justify-center items-center p-8 bg-gradient-to-br from-orange-50 to-purple-50 dark:from-background dark:to-card">
          <img src="/icons/icon.svg" alt="Logo" className="h-12 w-12 mb-4" />
          <h1 className="text-3xl font-bold mb-2 text-primary">Sign in to Hintword</h1>
          <p className="mb-6 text-muted-foreground">Your tabs, notes, and focus—everywhere.</p>
          {!isChromeExtension ? (
            <GoogleOAuthProvider clientId={clientId}>
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => {
                  alert("Login Failed");
                }}
                useOneTap
                width="300"
                text="continue_with"
                shape="pill"
                theme="filled_blue"
              />
            </GoogleOAuthProvider>
          ) : (
            <button
              className="flex items-center gap-3 px-6 py-3 rounded-full bg-white shadow border border-gray-200 hover:bg-gray-50 transition text-base font-medium"
              style={{ minWidth: 240 }}
              onClick={handleExtensionLogin}
            >
              <img
                src="https://www.gstatic.com/marketing-cms/assets/images/d5/dc/cfe9ce8b4425b410b49b7f2dd3f3/g.webp=s96-fcrop64=1,00000000ffffffff-rw"
                alt="Google"
                className="w-6 h-6"
                style={{ borderRadius: '50%' }}
              />
              <span className="text-gray-800">Sign in with Google</span>
            </button>
          )}
          <p className="mt-8 text-xs text-muted-foreground">
            By signing in, you agree to our <a href="/terms" className="underline">Terms</a> and <a href="/privacy" className="underline">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </PublicRoute>
  );
}

function jwt_decode(idToken: any) {
  throw new Error("Function not implemented.");
}
